'use client'
import React, { FC } from 'react'
import { Button, HStack, Icon, Text } from '@chakra-ui/react'
import { IoMapOutline } from 'react-icons/io5'
import { gtmEvent, RealestateDetailMapClick } from '@/utils/gtm'
import { useClientLocale } from '@/hooks/use-locale-config'

interface MapButtonProps {}

const MapButton: FC<MapButtonProps> = () => {
  const locale = useClientLocale()
  const executeScroll = () => {
    gtmEvent<RealestateDetailMapClick>({
      name: 'realestate_detail_map_click',
      locale,
      params: {}
    })
    const myElement = document.getElementById('realestate-detail-map')

    if (myElement) {
      myElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <Button
      minW="auto"
      size="sm"
      bg="background.surface"
      fontWeight="normal"
      rounded="full"
      onClick={executeScroll}>
      <HStack as="span" w="full">
        <Icon as={IoMapOutline} boxSize={4} />
        <Text as="span" fontSize="md" fontWeight="600" color="text.default">
          Mapa
        </Text>
      </HStack>
    </Button>
  )
}

export default MapButton
